module.exports = __webpack_public_path__ + "media/my_images/search/pre-7e29bf9bae49a8446cca076cb693c4cd.svg";